<!-- src/components/Footer.vue -->
<template>
	<footer data-aos="fade-up">
		
	</footer>
</template>

<script setup></script>

<style scoped></style>
